import { track } from '@vercel/analytics';

type AnalyticsValue = string | number | boolean | null | undefined;

export function trackCommerceEvent(name: string, properties?: Record<string, AnalyticsValue>) {
  const sanitizedEntries = Object.entries(properties ?? {}).filter(([, value]) => value !== undefined);

  try {
    void track(name, Object.fromEntries(sanitizedEntries));
  } catch {
    // Analytics should never block the user flow.
  }
}
